import { makeSelectCartEvaluationRequiresTripRequestForm } from './makeSelectCartEvaluationRequiresTripRequestForm'

/** Whether the trip request form should show: any evaluated cart item plus a required approval. */
export const selectShouldShowTripRequestForm = makeSelectCartEvaluationRequiresTripRequestForm()
